/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {DISMISS_MSG} from '../../../../common/constants';
import {RegionService} from '../../../../services/region.service';

@Component({
    selector: 'app-add-subregion-pop-up',
    templateUrl: './add-subregion-pop-up.component.html',
    styleUrl: './add-subregion-pop-up.component.scss',
    standalone: false
})
export class AddSubregionPopUpComponent {
  subregionName: string;
  regions: any[];
  selectedRegion: string;
  showSpinner: boolean;


  constructor(public readonly regionService: RegionService,
              public dialogRef: MatDialogRef<AddSubregionPopUpComponent>,
              public snackBar: FabMessageService) {
    this.getRegions();
  }

  /**
   * Gets all regions
   */
  getRegions() {
    this.showSpinner = true;
    this.regionService.getAllRegions().subscribe({
        next: (response) => {
          this.regions = response;
        },
        error: () => {
          this.showSpinner = false;
          this.snackBar.displayError('Error loading regions', DISMISS_MSG);
        },
        complete: () => {
          this.showSpinner = false;
        }
      }
    );
  }

  /**
   * Adds a new planning market
   */
  addSubregion(): void {
    this.dialogRef.close({
      data: {subregionName: this.subregionName, region: this.selectedRegion}
    });
  }
}
